<template>
<div class="chapter">
<div class="inner_page">
<div class="epigraphPage">
<a id="title62"></a>
<div class="verse"><span>Heaven says nothing, and the whole earth grows rich beneath its silent rule. Men, too, are touched by heaven’s virtue; yet, in their greater part, they are creatures of deceit. They are born, it seems, with an emptiness of soul, and must take their qualities wholly from things without. To be born thus empty into this modern age, this mixture of good and ill, and yet to steer through life on an honest course to the splendors of success—this is a feat reserved for paragons of our kind, a task beyond the nature of normal man.</span></div>
<div class="source"><span>—Ihara Saikaku</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429969635_epi01.vue?1a95c59d